// Shared vocab display helpers.

// True when a word's romanization actually adds information. Most later-unit
// rows just repeat the Vietnamese word verbatim, and rendering "pronounced má"
// under "má" reads like a bug — hide the line in that case.
export function romanizationDiffers(word) {
  const r = word?.word_romanization
  if (!r) return false
  return r.trim().toLowerCase() !== (word.word_vietnamese || '').trim().toLowerCase()
}
